import sessaoStore from "./SessaoStore";
import loginStore from "../views/autenticacao/stores/LoginStore";
import dashboardStore from "../views/dashboard/stores/DashboardStore";
import quadroComposicaoTaxaBDIStore from "../views/configuracoes/stores/QuadroComposicaoTaxaBDIStore";
import encargosSociaisMaoObraStore from "../views/configuracoes/stores/EncargosSociaisMaoObraStore";
import empresaStore from "../views/configuracoes/stores/EmpresaStore";
import perfilStore from "../views/seguranca/stores/PerfilStore";
import grupoStore from "../views/cadastros/grupos/stores/GrupoStore";
import insumoStore from "../views/cadastros/insumos/stores/InsumoStore";
import usuarioStore from "../views/cadastros/usuarios/stores/UsuarioStore";
import composicaoStore from "../views/cadastros/composicoes/stores/ComposicaoStore";
import orcamentoStore from "../views/cadastros/orcamentos/stores/OrcamentoStore";
import etapaStore from "../views/cadastros/orcamentos/stores/EtapaStore";
import servicoStore from "../views/cadastros/orcamentos/stores/ServicoStore";
import planilhaOrcamentoStore from "../views/cadastros/orcamentos/stores/PlanilhaStore";
import cronogramaOrcamentoStore from "../views/cadastros/orcamentos/stores/CronogramaStore";

export {
  loginStore,
  sessaoStore,
  dashboardStore,
  quadroComposicaoTaxaBDIStore,
  encargosSociaisMaoObraStore,
  empresaStore,
  perfilStore,
  grupoStore,
  insumoStore,
  usuarioStore,
  composicaoStore,
  orcamentoStore,
  etapaStore,
  servicoStore,
  planilhaOrcamentoStore,
  cronogramaOrcamentoStore
};



// WEBPACK FOOTER //
// ./src/stores/index.js